<template>
	<div class="flex items-center">
		<div class="w-3 phablet:w-12 h-1 bg-secondary rounded-2xl mr-4" />
		<p class="text-xl mobile:text-2xl desktop:text-4xl font-bold">
			<slot />
		</p>
	</div>
</template>
